import React, { SVGProps, useContext } from 'react'
import AppContext from '../../app/context'

const RightDecorationIcon = (props: SVGProps<SVGSVGElement>) => {
  const { state } = useContext(AppContext)
  if (!state.locationDesignConfig) return null

  return (
    <svg
      {...props}
      viewBox="0 0 318 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M244.5 0.716058C289.929 0.597028 334.931 9.49588 376.9 26.8973C418.869 44.2987 456.971 69.8569 489 102.092L428.043 163.083C379.364 114.379 313.342 87.0167 244.5 87.0166C175.658 87.0166 109.636 114.379 60.9572 163.083L5.33201e-06 102.092C32.0241 69.85 70.125 44.2871 112.095 26.8853C154.065 9.4834 199.069 0.58846 244.5 0.716058Z"
        fill={state.locationDesignConfig?.baseColors.primary}
      />
    </svg>
  )
}

export default RightDecorationIcon
